import React from 'react';
import { usePrivateLayoutTitle } from './usePrivateLayoutTitle';
import { useMediaQuery, useTheme } from '@mui/material';
import { Button } from '~/UIKit';
import { PrivateLayoutOptionsMenu } from './PrivateLayoutOptionsMenu';
import { PrivateLayoutOptions } from '../PrivateLayout';
import { makeStyles } from '~/UIKit/Style';
import { useTranslation } from 'react-i18next';

interface IPrivateLayoutTitleActionsProps {
  options?: PrivateLayoutOptions[];
  actionName?: string;
  actionDisabled?: boolean;
  onActionTaken?: () => void;
  secondaryAction?: JSX.Element | null;
}

const useStyles = makeStyles({
  button: {
    marginRight: 0,
    marginLeft: 'auto',
  },
});

export function PrivateLayoutTitleActions({
  options,
  actionName,
  actionDisabled,
  onActionTaken,
  secondaryAction,
}: IPrivateLayoutTitleActionsProps) {
  const { anchorEl, handleMountMenu, handleCloseMenu } = usePrivateLayoutTitle();
  const { classes } = useStyles();

  const theme = useTheme();
  const { t } = useTranslation();
  const mobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <>
      {secondaryAction}
      {!mobile && actionName && (
        <Button
          data-testid="title.actionButton"
          className={classes.button}
          disabled={actionDisabled}
          variant="contained"
          size="medium"
          onClick={onActionTaken}
        >
          {actionName}
        </Button>
      )}
      {options && !mobile && (
        <>
          <Button
            size="medium"
            variant="outlined"
            onClick={handleMountMenu}
            data-testid="PrivateLayoutTitle_OptionsMenu"
          >
            {t('app.options')}
          </Button>
          <PrivateLayoutOptionsMenu
            handleCloseMenu={handleCloseMenu}
            anchorEl={anchorEl}
            options={options}
          />
        </>
      )}
    </>
  );
}
